import * as React from 'react';

interface LargeAddIconProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
  size?: number;
}

const LargeAddIcon: React.FC<LargeAddIconProps> = ({color = '#212124', size = 20, ...props}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" {...props}>
    <path fill={color} d="M11.094 8.906V1.25H8.906v7.656H1.25v2.188h7.656v7.656h2.188v-7.656h7.656V8.906h-7.656Z" />
  </svg>
);
export default LargeAddIcon;
